var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "start overflow-visible pb-16"
  }, [_c('router-view'), _c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('video-dialog', {
    attrs: {
      "hash": "#intro",
      "poster": "https://cdn.ellacard.com/start/group_video_intro_poster.jpg",
      "src": `https://cdn.ellacard.com/start/group_video_intro_hd${_vm.IS_MOBILE ? '480' : '720'}.mp4`
    }
  }), _c('h2', {
    staticClass: "mt-6 text-h4 text-md-h3 header-font text-center"
  }, [_vm._v("What type of video do you want to make?")]), _c('div', {
    staticClass: "mx-n2 py-6 py-sm-12 text-center"
  }, [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "active-class": "primary white--text",
      "disabled": _vm.loadStatus.pending && !(!_vm.$route.query.q || !_vm.$route.query.q.length),
      "input-value": !_vm.$route.query.q || !_vm.$route.query.q.length
    },
    on: {
      "click": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          query: Object.assign({}, _vm.$route.query, {
            q: undefined
          })
        }));
      }
    }
  }, [_vm._v(" All ")]), _c('div', {
    staticClass: "ma-2 d-inline-block btn-group btn-group-horizontal"
  }, _vm._l(_vm.FIXED_CHIPS.slice(0, 2), function (_ref) {
    var name = _ref[0],
      icon = _ref[1];
    return _c('v-chip', {
      key: 'chip-' + name,
      attrs: {
        "active-class": "primary white--text",
        "disabled": _vm.loadStatus.pending && !_vm.queryTerms.includes(name),
        "input-value": _vm.queryTerms.includes(name)
      },
      on: {
        "click": function ($event) {
          return _vm.toggle(name);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(" " + _vm._s(name) + " ")], 1);
  }), 1), _vm._l(_vm.FIXED_CHIPS.slice(2), function (_ref2) {
    var name = _ref2[0],
      icon = _ref2[1];
    return _c('v-chip', {
      key: 'chip-' + name,
      staticClass: "ma-2",
      attrs: {
        "active-class": "primary white--text",
        "disabled": _vm.loadStatus.pending && !_vm.queryTerms.includes(name),
        "input-value": _vm.queryTerms.includes(name)
      },
      on: {
        "click": function ($event) {
          return _vm.toggle(name);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(" " + _vm._s(name) + " ")], 1);
  }), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-chip', _vm._g({
          staticClass: "ma-2",
          attrs: {
            "active-class": "primary white--text",
            "disabled": _vm.loadStatus.pending && !_vm.queryTerms.filter(function (x) {
              return !_vm.FIXED_CHIPS.map(function (y) {
                return y[0];
              }).includes(x);
            }).length,
            "input-value": _vm.queryTerms.filter(function (x) {
              return !_vm.FIXED_CHIPS.map(function (y) {
                return y[0];
              }).includes(x);
            }).length > 0
          }
        }, on), [_vm._v(" More… "), _c('v-icon', {
          attrs: {
            "right": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronDown)
          }
        })], 1)];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l(_vm.categories, function (_ref4) {
    var name = _ref4[0],
      icon = _ref4[1],
      iconColor = _ref4[2],
      textClass = _ref4[3],
      isDefault = _ref4[4];
    return name != 'Template' ? [name ? _c('v-list-item', {
      attrs: {
        "input-value": _vm.queryTerms.includes(name)
      },
      on: {
        "click": function ($event) {
          return _vm.toggle(name);
        }
      }
    }, [_c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": iconColor
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      class: textClass + (isDefault ? '' : ' font-weight-bold'),
      domProps: {
        "innerHTML": _vm._f("category")(name)
      }
    })], 1)], 1) : _c('v-divider', {
      staticClass: "my-2"
    })] : _vm._e();
  })], 2)], 1)], 2), _c('div', {
    staticClass: "mt-6 grid-alternate dense"
  }, [_vm._l(_vm.templates, function (t) {
    return [_c('router-link', {
      staticClass: "hover-pop d-inline-block overflow-hidden rounded-xl black",
      staticStyle: {
        "aspect-ratio": "16 / 9",
        "width": "min(400px, 100%)",
        "max-width": "80vw"
      },
      attrs: {
        "title": t.name + ' video template',
        "to": {
          name: 'video-template',
          params: {
            templateId: t.id
          },
          query: _vm.$route.query
        }
      }
    }, [_c('v-img', {
      attrs: {
        "width": "100%",
        "alt": t.name + ' video template poster',
        "src": t.poster
      }
    })], 1), _c('div', [_c('h4', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(t.name))]), _c('div', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(t.description))]), _c('v-btn', {
      staticClass: "btn-pop",
      attrs: {
        "rounded": "",
        "dark": "",
        "large": "",
        "color": "ec-blue",
        "title": t.name + ' video template',
        "to": {
          name: 'video-template',
          params: {
            templateId: t.id
          },
          query: _vm.$route.query
        }
      }
    }, [_vm._v(" Make this video… ")])], 1)];
  })], 2), _vm.foundNothing ? _c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("No video themes found")]), _c('div', {
    staticClass: "text-center"
  }, _vm._l(_vm.queryTerms, function (tag) {
    return _c('v-chip', {
      key: tag,
      staticClass: "ma-2"
    }, [_vm._v(_vm._s(_vm._f("category")(tag)))]);
  }), 1), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.search();
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiClose))])], 1), _c('div', {
    staticClass: "title mt-8"
  }, [_vm._v("Can't find the perfect video theme? "), _c('a', {
    attrs: {
      "href": `mailto:ideas@ellacard.com?subject=${encodeURIComponent('Idea for a video theme')}`
    }
  }, [_vm._v("Tell us")]), _vm._v(" your ideas – we're constantly adding more!")])], 1) : _vm._e(), _vm.after || _vm.loadStatus.pending ? _c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('v-progress-circular', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect.quiet",
      value: function (entries) {
        return (entries[0] || {}).isIntersecting && _vm.loadStatus.promise.then(_vm.load);
      },
      expression: "entries => (entries[0] || {}).isIntersecting && loadStatus.promise.then(load)",
      modifiers: {
        "quiet": true
      }
    }],
    staticClass: "my-4",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }